
import { Container } from '@mui/material';

export default function GestRepresentantes({ element: component, ...rest }) {
    // const classes = useStyles()

    return (<Container>{component} </Container>)
}